import { Injectable } from '@angular/core';
import { GlobalService } from '@common/global';
import { HttpParams } from '@angular/common/http';
import { ApiService } from '@services/api.service';
@Injectable({
  providedIn: 'root'
})
export class ApiDocService {

  constructor(private api: ApiService, private _common: GlobalService) { }
  apidoc(obj) {
    let params = new HttpParams();
    //Object.entries(obj).forEach(([key, value]) => {
   //   params = params.append(key, obj[key]);
  //  });
    return this.api.call('apidoc', params);
  }
}
